module.exports = __webpack_public_path__ + "static/media/ACHSWhiteLogo.1e85ad34.svg";